import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.13.1_@upstash+red_1394b70abd98536012376ec3d35499b7/node_modules/nuxt/dist/pages/runtime/validate.js";
import previous_45path_45global from "/vercel/path0/apps/be.unity.org/app/middleware/previous-path.global.ts";
import start_45url_45global from "/vercel/path0/apps/be.unity.org/app/middleware/start-url.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.13.1_@upstash+red_1394b70abd98536012376ec3d35499b7/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  previous_45path_45global,
  start_45url_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "cache-control": () => import("/vercel/path0/apps/be.unity.org/app/middleware/cache-control.ts"),
  auth: () => import("/vercel/path0/node_modules/.pnpm/@sidebase+nuxt-auth@0.8.2_@netlify+blobs@9.1.2_@upstash+redis@1.34.4_@vercel+kv@2.0.0_m_4f9ba3db8cbc65337af9f81bcdf849a5/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.mjs")
}